import { useMonitorQuery, useEthereumPrice } from "@monegraph/graph"

import { gql } from "apollo-boost"

export function useMonitorPublicMint(publicMintId: string) {
  const { contents: ethereumValue } = useEthereumPrice()

  return useMonitorQuery(
    {
      query: PUBLIC_MINT_QUERY,
      variables: {
        id: publicMintId,
      },
      validate: {
        ethereumValue,
      },
      transform({ data }) {
        if (data) {
          return data.publicMints[0]
        }
      },
    },
    [publicMintId, ethereumValue]
  )
}

const PUBLIC_MINT_QUERY = gql`
  query fetchPublicMint($id: ID) {
    publicMints(first: 1, where: { id: $id }) {
      id
      name
      collection {
        id
        type
      }
      allowlist {
        id
        enabled
        start
        end
        quantity
        discount
        wallets {
          id
        }
      }
      general {
        id
        enabled
        start
        end
        quantity
        discount
      }
      conditions {
        id
        type
        quantity
        discount
        payload
      }
      tokens {
        id
        tokenId
        metadata
        quantity
        cost
        attributes {
          language
          artist
          year
          royalty
          title
        }
      }
      recipients {
        id
        definition {
          tokenId
        }
        account {
          id
        }
        dateMinted
      }
    }
    _meta {
      block {
        number
      }
    }
  }
`
